'use strict';
module.exports = require('../../full/json/stringify');
